import axios from 'axios';

// Get OAuth 2.0 office access token
export const getOfficeAccessToken = async () => {
	try {
		// Wait for Office.js to be ready
		await Office.onReady();

		if (!Office?.auth?.getAccessToken) {
			throw new Error('Could not authenticate. Please try refreshing the page or restarting the app.');
		}

		const officeAccessToken = await Office.auth.getAccessToken({
			allowSignInPrompt: true,
			allowConsentPrompt: true,
		});
		console.log('officeAccessToken', officeAccessToken);
		return {
			success: true,
			data: officeAccessToken,
		};
	} catch (error) {
		console.log('Error obtaining office access token', error);
		return {
			success: false,
			data: error,
		};
	}
};

// User sign in using Oauth office access token token
export const loginToUrl = async ({ officeAccessToken, loginUrl }) => {
	return await axios.get(loginUrl, {
		headers: {
			Authorization: `Bearer ${officeAccessToken}`,
		},
	});
};
